import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: unknown; output: unknown; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: unknown; output: unknown; }
  Upload: { input: unknown; output: unknown; }
};

/** Autogenerated return type of AcceptInvitation. */
export type AcceptInvitationPayload = {
  __typename?: 'AcceptInvitationPayload';
  projectMembership: ProjectMembership;
};

/** Input for accepting a user invitation */
export type AcceptUserInvitationInput = {
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of AcceptUserInvitation. */
export type AcceptUserInvitationPayload = {
  __typename?: 'AcceptUserInvitationPayload';
  user: User;
};

export type Attachment = {
  __typename?: 'Attachment';
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Input for changing user password */
export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

/** Autogenerated return type of ChangePassword. */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  success: Scalars['Boolean']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  installments: Array<Installment>;
  name: Scalars['String']['output'];
  numberOfInstallments: Scalars['Int']['output'];
  project: Project;
  startDate: Scalars['ISO8601Date']['output'];
  status: ContractStatusEnum;
  totalValue: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: Array<User>;
};

export enum ContractStatusEnum {
  /** Complete */
  Complete = 'COMPLETE',
  /** Overdue */
  Overdue = 'OVERDUE',
  /** Paid */
  Paid = 'PAID',
  /** Pending */
  Pending = 'PENDING'
}

/** Input for creating a diary entry */
export type CreateDiaryEntryInput = {
  date: Scalars['ISO8601Date']['input'];
  description: Scalars['String']['input'];
  siteInspectionId: Scalars['ID']['input'];
  status: DiaryStatusTypeEnum;
  /** Tag slug or name; creates tag if not found */
  tagSlug?: InputMaybe<Scalars['String']['input']>;
  weather?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDiaryEntry. */
export type CreateDiaryEntryPayload = {
  __typename?: 'CreateDiaryEntryPayload';
  diaryEntry: DiaryEntry;
};

/** Autogenerated return type of CreateDocument. */
export type CreateDocumentPayload = {
  __typename?: 'CreateDocumentPayload';
  document: Document;
};

/** Autogenerated return type of CreateFinancialEntry. */
export type CreateFinancialEntryPayload = {
  __typename?: 'CreateFinancialEntryPayload';
  financialEntry: FinancialEntry;
};

/** Autogenerated return type of CreateProject. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  project: Project;
};

/** Autogenerated return type of CreateSiteInspection. */
export type CreateSiteInspectionPayload = {
  __typename?: 'CreateSiteInspectionPayload';
  siteInspection: SiteInspection;
};

/** Input for creating a new user */
export type CreateUserInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  role?: InputMaybe<UserRole>;
};

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  user: User;
};

/** Autogenerated return type of DeleteDiaryEntry. */
export type DeleteDiaryEntryPayload = {
  __typename?: 'DeleteDiaryEntryPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteDocument. */
export type DeleteDocumentPayload = {
  __typename?: 'DeleteDocumentPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteProjectFile. */
export type DeleteProjectFilePayload = {
  __typename?: 'DeleteProjectFilePayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteProject. */
export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteSiteInspection. */
export type DeleteSiteInspectionPayload = {
  __typename?: 'DeleteSiteInspectionPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteUser. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  user?: Maybe<User>;
};

export type DiaryEntry = {
  __typename?: 'DiaryEntry';
  author: User;
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  /** Metadata about this entry's project files (counts, etc.). Extensible for future fields. */
  projectFileMetadata: ProjectFileMetadata;
  projectFiles: Array<ProjectFile>;
  siteInspection: SiteInspection;
  status: DiaryStatusTypeEnum;
  tag?: Maybe<Tag>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  weather?: Maybe<Scalars['String']['output']>;
};

export enum DiaryStatusTypeEnum {
  /** Ahead of schedule */
  AheadOfSchedule = 'AHEAD_OF_SCHEDULE',
  /** Work was delayed */
  Delayed = 'DELAYED',
  /** An issue occurred */
  Issue = 'ISSUE',
  /** Important milestone achieved */
  Milestone = 'MILESTONE',
  /** Normal day, no issues */
  Normal = 'NORMAL'
}

export type Document = {
  __typename?: 'Document';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentType: DocumentTypeEnum;
  /** Original filename from attachment (for display when title is null) */
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** File size in bytes */
  size: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['ISO8601DateTime']['output'];
  uploadedBy: User;
  url?: Maybe<Scalars['String']['output']>;
  visibility: DocumentVisibilityEnum;
};

export enum DocumentTypeEnum {
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Project = 'PROJECT'
}

export enum DocumentVisibilityEnum {
  /** Visible only to admins and collaborators */
  Internal = 'INTERNAL',
  /** Visible to all project members (public) */
  Shared = 'SHARED'
}

export type FinancialEntry = {
  __typename?: 'FinancialEntry';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  description: Scalars['String']['output'];
  documents: Array<Attachment>;
  dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  entryType: TransactionKindEnum;
  id: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  project: Project;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: FinancialStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum FinancialStatusEnum {
  /** Payment was cancelled */
  Cancelled = 'CANCELLED',
  /** Payment is overdue */
  Overdue = 'OVERDUE',
  /** Payment has been made */
  Paid = 'PAID',
  /** Pending payment */
  Pending = 'PENDING'
}

export type FinancialSummary = {
  __typename?: 'FinancialSummary';
  balance: Scalars['Float']['output'];
  nextDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  overdueAmount: Scalars['Float']['output'];
  totalCharges: Scalars['Float']['output'];
  totalCredits: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
};

export type Installment = {
  __typename?: 'Installment';
  amount: Scalars['Float']['output'];
  contract: Contract;
  dueDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: InstallmentStatusEnum;
};

export enum InstallmentStatusEnum {
  /** Overdue */
  Overdue = 'OVERDUE',
  /** Paid */
  Paid = 'PAID',
  /** Pending */
  Pending = 'PENDING'
}

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  inviterName: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectName: Scalars['String']['output'];
  status: InvitationStatus;
  userExists: Scalars['Boolean']['output'];
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** Input for inviting a new user */
export type InviteUserInput = {
  email: Scalars['String']['input'];
  role?: InputMaybe<UserRole>;
};

/** Autogenerated return type of InviteUser. */
export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  user: User;
};

/** Autogenerated return type of InviteUserToProject. */
export type InviteUserToProjectPayload = {
  __typename?: 'InviteUserToProjectPayload';
  invitation: Invitation;
};

/** Autogenerated return type of MarkFinancialEntryAsPaid. */
export type MarkFinancialEntryAsPaidPayload = {
  __typename?: 'MarkFinancialEntryAsPaidPayload';
  financialEntry: FinancialEntry;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation?: Maybe<AcceptInvitationPayload>;
  /** Accept a user invitation by setting password */
  acceptUserInvitation?: Maybe<AcceptUserInvitationPayload>;
  /** Change user password (for forced password change flow) */
  changePassword?: Maybe<ChangePasswordPayload>;
  createDiaryEntry?: Maybe<CreateDiaryEntryPayload>;
  createDocument?: Maybe<CreateDocumentPayload>;
  createFinancialEntry?: Maybe<CreateFinancialEntryPayload>;
  createProject?: Maybe<CreateProjectPayload>;
  createSiteInspection?: Maybe<CreateSiteInspectionPayload>;
  /** Create a new user (admin only) */
  createUser?: Maybe<CreateUserPayload>;
  deleteDiaryEntry?: Maybe<DeleteDiaryEntryPayload>;
  deleteDocument?: Maybe<DeleteDocumentPayload>;
  deleteProject?: Maybe<DeleteProjectPayload>;
  deleteProjectFile?: Maybe<DeleteProjectFilePayload>;
  deleteSiteInspection?: Maybe<DeleteSiteInspectionPayload>;
  /** Hard delete a user (admin only, invited users only) */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Invite a new user by email (admin only) — creates or reuses a pending user record */
  inviteUser?: Maybe<InviteUserPayload>;
  inviteUserToProject?: Maybe<InviteUserToProjectPayload>;
  markFinancialEntryAsPaid?: Maybe<MarkFinancialEntryAsPaidPayload>;
  removeProjectMember?: Maybe<RemoveProjectMemberPayload>;
  /** Resend an invitation email for an existing invited user (admin only) */
  resendInvitation?: Maybe<ResendInvitationPayload>;
  /** Sign in a user */
  signIn?: Maybe<SignInPayload>;
  /** Sign out the current user */
  signOut?: Maybe<SignOutPayload>;
  signUp?: Maybe<SignUpPayload>;
  signUpWithInvitation?: Maybe<SignUpWithInvitationPayload>;
  updateDiaryEntry?: Maybe<UpdateDiaryEntryPayload>;
  updateDocument?: Maybe<UpdateDocumentPayload>;
  updateProject?: Maybe<UpdateProjectPayload>;
  updateProjectFile?: Maybe<UpdateProjectFilePayload>;
  /** Update a user (activate/deactivate, admin only) */
  updateUser?: Maybe<UpdateUserPayload>;
  uploadProjectFile?: Maybe<UploadProjectFilePayload>;
};


export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcceptUserInvitationArgs = {
  input: AcceptUserInvitationInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCreateDiaryEntryArgs = {
  input: CreateDiaryEntryInput;
};


export type MutationCreateDocumentArgs = {
  attachment: Scalars['Upload']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<DocumentTypeEnum>;
  projectId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<DocumentVisibilityEnum>;
};


export type MutationCreateFinancialEntryArgs = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  entryType: TransactionKindEnum;
  projectId: Scalars['ID']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateProjectArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  hasAdhocTracking?: InputMaybe<Scalars['Boolean']['input']>;
  hasConstructionTracking?: InputMaybe<Scalars['Boolean']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationCreateSiteInspectionArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteDiaryEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSiteInspectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationInviteUserToProjectArgs = {
  email: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationMarkFinancialEntryAsPaidArgs = {
  id: Scalars['ID']['input'];
  paidAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type MutationRemoveProjectMemberArgs = {
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationResendInvitationArgs = {
  email: Scalars['String']['input'];
};


export type MutationSignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationSignUpArgs = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  role?: InputMaybe<UserRole>;
};


export type MutationSignUpWithInvitationArgs = {
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateDiaryEntryArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<DiaryStatusTypeEnum>;
  tagSlug?: InputMaybe<Scalars['String']['input']>;
  weather?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<DocumentTypeEnum>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<DocumentVisibilityEnum>;
};


export type MutationUpdateProjectArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  hasAdhocTracking?: InputMaybe<Scalars['Boolean']['input']>;
  hasConstructionTracking?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  status?: InputMaybe<ProjectStatus>;
};


export type MutationUpdateProjectFileArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ProjectFileVisibilityEnum>;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationUploadProjectFileArgs = {
  attachment: Scalars['Upload']['input'];
  category: ProjectFileCategoryEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  diaryEntryId?: InputMaybe<Scalars['ID']['input']>;
  fileType: ProjectFileKindEnum;
  folder?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ProjectFileVisibilityEnum>;
};

/** Pagination metadata from Pagy (https://github.com/ddnexus/pagy) */
export type Page = {
  __typename?: 'Page';
  /** Current page number (Pagy: page) */
  currentPage: Scalars['Int']['output'];
  /** 1-based index of first item on this page, or 0 when empty (Pagy: from) */
  from?: Maybe<Scalars['Int']['output']>;
  /** Number of items on the current page (Pagy: in; may be less than limit on last page) */
  itemsInPage: Scalars['Int']['output'];
  /** Requested items per page (Pagy: limit) */
  limit: Scalars['Int']['output'];
  /** Next page number, or null if last page (Pagy: next) */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Previous page number, or null if first page (Pagy: prev) */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Page numbers and gaps for nav: integers as strings, current page as string, gaps as "gap" (Pagy: series) */
  series: Array<Scalars['String']['output']>;
  /** 1-based index of last item on this page, or 0 when empty (Pagy: to) */
  to?: Maybe<Scalars['Int']['output']>;
  /** Total number of items across all pages (Pagy: count) */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages (Pagy: pages/last) */
  totalPages: Scalars['Int']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Project = {
  __typename?: 'Project';
  address?: Maybe<Scalars['String']['output']>;
  clients: Array<User>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  hasAdhocTracking: Scalars['Boolean']['output'];
  hasConstructionTracking: Scalars['Boolean']['output'];
  /** Whether the current user has access to any financial contracts in this project */
  hasFinancialAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  members: Array<User>;
  name: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  /** Metadata about project files (counts, etc.). Respects visibility. Extensible for future fields. */
  projectFileMetadata?: Maybe<ProjectFileMetadata>;
  siteInspections: Array<SiteInspection>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  status: ProjectStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Project. */
export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

export type ProjectFile = {
  __typename?: 'ProjectFile';
  category: ProjectFileCategoryEnum;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  diaryEntryId?: Maybe<Scalars['ID']['output']>;
  fileType: ProjectFileKindEnum;
  folder?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Human-readable file type (e.g. Image, PDF, Document) */
  mediaType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** File size in bytes */
  size: Scalars['Int']['output'];
  uploadedAt: Scalars['ISO8601DateTime']['output'];
  uploadedBy: User;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  visibility: ProjectFileVisibilityEnum;
};

export enum ProjectFileCategoryEnum {
  Construction = 'CONSTRUCTION',
  Financial = 'FINANCIAL',
  Legal = 'LEGAL',
  Project = 'PROJECT'
}

export type ProjectFileCountByMedia = {
  __typename?: 'ProjectFileCountByMedia';
  /** Number of files of this type */
  count: Scalars['Int']['output'];
  /** Display file type (e.g. PDF, Image, Document) */
  mediaType: Scalars['String']['output'];
};

export enum ProjectFileKindEnum {
  Document = 'DOCUMENT',
  FloorPlan = 'FLOOR_PLAN',
  Other = 'OTHER',
  Photo = 'PHOTO',
  Rendering = 'RENDERING'
}

/** Metadata about project files (counts, etc.). Extensible for future fields. */
export type ProjectFileMetadata = {
  __typename?: 'ProjectFileMetadata';
  /** Count of files grouped by media type (PDF, Image, etc.) */
  countsByMediaType: Array<ProjectFileCountByMedia>;
};

export enum ProjectFileVisibilityEnum {
  /** Visible only to admins and collaborators */
  Internal = 'INTERNAL',
  /** Visible to all project members */
  Shared = 'SHARED'
}

export type ProjectFinancialSummary = {
  __typename?: 'ProjectFinancialSummary';
  balance: Scalars['Float']['output'];
  totalContractsValue: Scalars['Float']['output'];
  totalOverdue: Scalars['Float']['output'];
  totalPaid: Scalars['Float']['output'];
  totalPending: Scalars['Float']['output'];
};

export type ProjectMembership = {
  __typename?: 'ProjectMembership';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export enum ProjectStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD',
  Planning = 'PLANNING'
}

export type Query = {
  __typename?: 'Query';
  currentUser?: Maybe<User>;
  /** Get diary entries for a project */
  diaryEntries: Array<DiaryEntry>;
  /** Get a single document by ID */
  document?: Maybe<Document>;
  /** Get documents for the uploads page */
  documents: Array<Document>;
  /** Get financial entries for a project */
  financialEntries: Array<FinancialEntry>;
  /** Get financial summary for a project */
  financialSummary: FinancialSummary;
  /** Get invitation details by token (public access) */
  invitation?: Maybe<Invitation>;
  /** List all invited/pending users (admin only) */
  invitedUsers: Array<User>;
  /** Get a specific project by ID */
  project?: Maybe<Project>;
  projectContracts: Array<Contract>;
  /** Get a single project file by ID */
  projectFile?: Maybe<ProjectFile>;
  /** Get project files (clients see only shared files) */
  projectFiles: Array<ProjectFile>;
  projectFinancialSummary: ProjectFinancialSummary;
  /** Get paginated site inspections for a project */
  projectSiteInspections: SiteInspectionPage;
  /** List projects accessible to the current user */
  projects: ProjectConnection;
  /** List tags, optionally filtered by slug search for autocomplete */
  tags: Array<Tag>;
  /** Get user invitation details by token (public access) */
  userInvitation?: Maybe<UserInvitation>;
  /** List all users (admin only) */
  users: Array<User>;
};


export type QueryDiaryEntriesArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  projectId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  status?: InputMaybe<DiaryStatusTypeEnum>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryFinancialEntriesArgs = {
  entryType?: InputMaybe<TransactionKindEnum>;
  projectId: Scalars['ID']['input'];
  status?: InputMaybe<FinancialStatusEnum>;
};


export type QueryFinancialSummaryArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryInvitationArgs = {
  token: Scalars['String']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectContractsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectFilesArgs = {
  fileType?: InputMaybe<ProjectFileKindEnum>;
  folder?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  visibility?: InputMaybe<ProjectFileVisibilityEnum>;
};


export type QueryProjectFinancialSummaryArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectSiteInspectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProjectStatus>;
};


export type QueryTagsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserInvitationArgs = {
  token: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveProjectMember. */
export type RemoveProjectMemberPayload = {
  __typename?: 'RemoveProjectMemberPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ResendInvitation. */
export type ResendInvitationPayload = {
  __typename?: 'ResendInvitationPayload';
  user: User;
};

/** Autogenerated return type of SignIn. */
export type SignInPayload = {
  __typename?: 'SignInPayload';
  user: User;
};

/** Autogenerated return type of SignOut. */
export type SignOutPayload = {
  __typename?: 'SignOutPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SignUp. */
export type SignUpPayload = {
  __typename?: 'SignUpPayload';
  user: User;
};

/** Autogenerated return type of SignUpWithInvitation. */
export type SignUpWithInvitationPayload = {
  __typename?: 'SignUpWithInvitationPayload';
  projectMembership: ProjectMembership;
  user: User;
};

export type SiteInspection = {
  __typename?: 'SiteInspection';
  createdAt: Scalars['ISO8601DateTime']['output'];
  diaryEntries: Array<DiaryEntry>;
  displayLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  sequence: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SiteInspectionPage = {
  __typename?: 'SiteInspectionPage';
  nodes: Array<SiteInspection>;
  pagination: Page;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum TransactionKindEnum {
  /** Amount owed by client */
  Charge = 'CHARGE',
  /** Credit/adjustment in favor of client */
  Credit = 'CREDIT',
  /** Payment received from client */
  Payment = 'PAYMENT'
}

/** Autogenerated return type of UpdateDiaryEntry. */
export type UpdateDiaryEntryPayload = {
  __typename?: 'UpdateDiaryEntryPayload';
  diaryEntry: DiaryEntry;
};

/** Autogenerated return type of UpdateDocument. */
export type UpdateDocumentPayload = {
  __typename?: 'UpdateDocumentPayload';
  document: Document;
};

/** Autogenerated return type of UpdateProjectFile. */
export type UpdateProjectFilePayload = {
  __typename?: 'UpdateProjectFilePayload';
  projectFile: ProjectFile;
};

/** Autogenerated return type of UpdateProject. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  project: Project;
};

/** Input for updating a user */
export type UpdateUserInput = {
  disabledAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  user: User;
};

/** Autogenerated return type of UploadProjectFile. */
export type UploadProjectFilePayload = {
  __typename?: 'UploadProjectFilePayload';
  projectFile: ProjectFile;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['ISO8601DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  forcePasswordChange: Scalars['Boolean']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invited: Scalars['Boolean']['output'];
  invitedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  role: UserRole;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invitee?: Maybe<User>;
  inviter: User;
  role: UserRole;
  status: Scalars['String']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  Client = 'CLIENT',
  Collaborator = 'COLLABORATOR'
}

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;





/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AcceptInvitationPayload: ResolverTypeWrapper<AcceptInvitationPayload>;
  AcceptUserInvitationInput: AcceptUserInvitationInput;
  AcceptUserInvitationPayload: ResolverTypeWrapper<AcceptUserInvitationPayload>;
  Attachment: ResolverTypeWrapper<Attachment>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  ChangePasswordInput: ChangePasswordInput;
  ChangePasswordPayload: ResolverTypeWrapper<ChangePasswordPayload>;
  Contract: ResolverTypeWrapper<Contract>;
  ContractStatusEnum: ContractStatusEnum;
  CreateDiaryEntryInput: CreateDiaryEntryInput;
  CreateDiaryEntryPayload: ResolverTypeWrapper<CreateDiaryEntryPayload>;
  CreateDocumentPayload: ResolverTypeWrapper<CreateDocumentPayload>;
  CreateFinancialEntryPayload: ResolverTypeWrapper<CreateFinancialEntryPayload>;
  CreateProjectPayload: ResolverTypeWrapper<CreateProjectPayload>;
  CreateSiteInspectionPayload: ResolverTypeWrapper<CreateSiteInspectionPayload>;
  CreateUserInput: CreateUserInput;
  CreateUserPayload: ResolverTypeWrapper<CreateUserPayload>;
  DeleteDiaryEntryPayload: ResolverTypeWrapper<DeleteDiaryEntryPayload>;
  DeleteDocumentPayload: ResolverTypeWrapper<DeleteDocumentPayload>;
  DeleteProjectFilePayload: ResolverTypeWrapper<DeleteProjectFilePayload>;
  DeleteProjectPayload: ResolverTypeWrapper<DeleteProjectPayload>;
  DeleteSiteInspectionPayload: ResolverTypeWrapper<DeleteSiteInspectionPayload>;
  DeleteUserPayload: ResolverTypeWrapper<DeleteUserPayload>;
  DiaryEntry: ResolverTypeWrapper<DiaryEntry>;
  DiaryStatusTypeEnum: DiaryStatusTypeEnum;
  Document: ResolverTypeWrapper<Document>;
  DocumentTypeEnum: DocumentTypeEnum;
  DocumentVisibilityEnum: DocumentVisibilityEnum;
  FinancialEntry: ResolverTypeWrapper<FinancialEntry>;
  FinancialStatusEnum: FinancialStatusEnum;
  FinancialSummary: ResolverTypeWrapper<FinancialSummary>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  ISO8601Date: ResolverTypeWrapper<Scalars['ISO8601Date']['output']>;
  ISO8601DateTime: ResolverTypeWrapper<Scalars['ISO8601DateTime']['output']>;
  Installment: ResolverTypeWrapper<Installment>;
  InstallmentStatusEnum: InstallmentStatusEnum;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Invitation: ResolverTypeWrapper<Invitation>;
  InvitationStatus: InvitationStatus;
  InviteUserInput: InviteUserInput;
  InviteUserPayload: ResolverTypeWrapper<InviteUserPayload>;
  InviteUserToProjectPayload: ResolverTypeWrapper<InviteUserToProjectPayload>;
  MarkFinancialEntryAsPaidPayload: ResolverTypeWrapper<MarkFinancialEntryAsPaidPayload>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Page: ResolverTypeWrapper<Page>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Project: ResolverTypeWrapper<Project>;
  ProjectConnection: ResolverTypeWrapper<ProjectConnection>;
  ProjectEdge: ResolverTypeWrapper<ProjectEdge>;
  ProjectFile: ResolverTypeWrapper<ProjectFile>;
  ProjectFileCategoryEnum: ProjectFileCategoryEnum;
  ProjectFileCountByMedia: ResolverTypeWrapper<ProjectFileCountByMedia>;
  ProjectFileKindEnum: ProjectFileKindEnum;
  ProjectFileMetadata: ResolverTypeWrapper<ProjectFileMetadata>;
  ProjectFileVisibilityEnum: ProjectFileVisibilityEnum;
  ProjectFinancialSummary: ResolverTypeWrapper<ProjectFinancialSummary>;
  ProjectMembership: ResolverTypeWrapper<ProjectMembership>;
  ProjectStatus: ProjectStatus;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  RemoveProjectMemberPayload: ResolverTypeWrapper<RemoveProjectMemberPayload>;
  ResendInvitationPayload: ResolverTypeWrapper<ResendInvitationPayload>;
  SignInPayload: ResolverTypeWrapper<SignInPayload>;
  SignOutPayload: ResolverTypeWrapper<SignOutPayload>;
  SignUpPayload: ResolverTypeWrapper<SignUpPayload>;
  SignUpWithInvitationPayload: ResolverTypeWrapper<SignUpWithInvitationPayload>;
  SiteInspection: ResolverTypeWrapper<SiteInspection>;
  SiteInspectionPage: ResolverTypeWrapper<SiteInspectionPage>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Tag: ResolverTypeWrapper<Tag>;
  TransactionKindEnum: TransactionKindEnum;
  UpdateDiaryEntryPayload: ResolverTypeWrapper<UpdateDiaryEntryPayload>;
  UpdateDocumentPayload: ResolverTypeWrapper<UpdateDocumentPayload>;
  UpdateProjectFilePayload: ResolverTypeWrapper<UpdateProjectFilePayload>;
  UpdateProjectPayload: ResolverTypeWrapper<UpdateProjectPayload>;
  UpdateUserInput: UpdateUserInput;
  UpdateUserPayload: ResolverTypeWrapper<UpdateUserPayload>;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  UploadProjectFilePayload: ResolverTypeWrapper<UploadProjectFilePayload>;
  User: ResolverTypeWrapper<User>;
  UserInvitation: ResolverTypeWrapper<UserInvitation>;
  UserRole: UserRole;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AcceptInvitationPayload: AcceptInvitationPayload;
  AcceptUserInvitationInput: AcceptUserInvitationInput;
  AcceptUserInvitationPayload: AcceptUserInvitationPayload;
  Attachment: Attachment;
  Boolean: Scalars['Boolean']['output'];
  ChangePasswordInput: ChangePasswordInput;
  ChangePasswordPayload: ChangePasswordPayload;
  Contract: Contract;
  CreateDiaryEntryInput: CreateDiaryEntryInput;
  CreateDiaryEntryPayload: CreateDiaryEntryPayload;
  CreateDocumentPayload: CreateDocumentPayload;
  CreateFinancialEntryPayload: CreateFinancialEntryPayload;
  CreateProjectPayload: CreateProjectPayload;
  CreateSiteInspectionPayload: CreateSiteInspectionPayload;
  CreateUserInput: CreateUserInput;
  CreateUserPayload: CreateUserPayload;
  DeleteDiaryEntryPayload: DeleteDiaryEntryPayload;
  DeleteDocumentPayload: DeleteDocumentPayload;
  DeleteProjectFilePayload: DeleteProjectFilePayload;
  DeleteProjectPayload: DeleteProjectPayload;
  DeleteSiteInspectionPayload: DeleteSiteInspectionPayload;
  DeleteUserPayload: DeleteUserPayload;
  DiaryEntry: DiaryEntry;
  Document: Document;
  FinancialEntry: FinancialEntry;
  FinancialSummary: FinancialSummary;
  Float: Scalars['Float']['output'];
  ID: Scalars['ID']['output'];
  ISO8601Date: Scalars['ISO8601Date']['output'];
  ISO8601DateTime: Scalars['ISO8601DateTime']['output'];
  Installment: Installment;
  Int: Scalars['Int']['output'];
  Invitation: Invitation;
  InviteUserInput: InviteUserInput;
  InviteUserPayload: InviteUserPayload;
  InviteUserToProjectPayload: InviteUserToProjectPayload;
  MarkFinancialEntryAsPaidPayload: MarkFinancialEntryAsPaidPayload;
  Mutation: Record<PropertyKey, never>;
  Page: Page;
  PageInfo: PageInfo;
  Project: Project;
  ProjectConnection: ProjectConnection;
  ProjectEdge: ProjectEdge;
  ProjectFile: ProjectFile;
  ProjectFileCountByMedia: ProjectFileCountByMedia;
  ProjectFileMetadata: ProjectFileMetadata;
  ProjectFinancialSummary: ProjectFinancialSummary;
  ProjectMembership: ProjectMembership;
  Query: Record<PropertyKey, never>;
  RemoveProjectMemberPayload: RemoveProjectMemberPayload;
  ResendInvitationPayload: ResendInvitationPayload;
  SignInPayload: SignInPayload;
  SignOutPayload: SignOutPayload;
  SignUpPayload: SignUpPayload;
  SignUpWithInvitationPayload: SignUpWithInvitationPayload;
  SiteInspection: SiteInspection;
  SiteInspectionPage: SiteInspectionPage;
  String: Scalars['String']['output'];
  Tag: Tag;
  UpdateDiaryEntryPayload: UpdateDiaryEntryPayload;
  UpdateDocumentPayload: UpdateDocumentPayload;
  UpdateProjectFilePayload: UpdateProjectFilePayload;
  UpdateProjectPayload: UpdateProjectPayload;
  UpdateUserInput: UpdateUserInput;
  UpdateUserPayload: UpdateUserPayload;
  Upload: Scalars['Upload']['output'];
  UploadProjectFilePayload: UploadProjectFilePayload;
  User: User;
  UserInvitation: UserInvitation;
}>;

export type AcceptInvitationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptInvitationPayload'] = ResolversParentTypes['AcceptInvitationPayload']> = ResolversObject<{
  projectMembership?: Resolver<ResolversTypes['ProjectMembership'], ParentType, ContextType>;
}>;

export type AcceptUserInvitationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptUserInvitationPayload'] = ResolversParentTypes['AcceptUserInvitationPayload']> = ResolversObject<{
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type AttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attachment'] = ResolversParentTypes['Attachment']> = ResolversObject<{
  byteSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ChangePasswordPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangePasswordPayload'] = ResolversParentTypes['ChangePasswordPayload']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type ContractResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contract'] = ResolversParentTypes['Contract']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  installments?: Resolver<Array<ResolversTypes['Installment']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numberOfInstallments?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ContractStatusEnum'], ParentType, ContextType>;
  totalValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
}>;

export type CreateDiaryEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDiaryEntryPayload'] = ResolversParentTypes['CreateDiaryEntryPayload']> = ResolversObject<{
  diaryEntry?: Resolver<ResolversTypes['DiaryEntry'], ParentType, ContextType>;
}>;

export type CreateDocumentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDocumentPayload'] = ResolversParentTypes['CreateDocumentPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['Document'], ParentType, ContextType>;
}>;

export type CreateFinancialEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFinancialEntryPayload'] = ResolversParentTypes['CreateFinancialEntryPayload']> = ResolversObject<{
  financialEntry?: Resolver<ResolversTypes['FinancialEntry'], ParentType, ContextType>;
}>;

export type CreateProjectPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateProjectPayload'] = ResolversParentTypes['CreateProjectPayload']> = ResolversObject<{
  project?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
}>;

export type CreateSiteInspectionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSiteInspectionPayload'] = ResolversParentTypes['CreateSiteInspectionPayload']> = ResolversObject<{
  siteInspection?: Resolver<ResolversTypes['SiteInspection'], ParentType, ContextType>;
}>;

export type CreateUserPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserPayload'] = ResolversParentTypes['CreateUserPayload']> = ResolversObject<{
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type DeleteDiaryEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteDiaryEntryPayload'] = ResolversParentTypes['DeleteDiaryEntryPayload']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type DeleteDocumentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteDocumentPayload'] = ResolversParentTypes['DeleteDocumentPayload']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type DeleteProjectFilePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteProjectFilePayload'] = ResolversParentTypes['DeleteProjectFilePayload']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type DeleteProjectPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteProjectPayload'] = ResolversParentTypes['DeleteProjectPayload']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type DeleteSiteInspectionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteSiteInspectionPayload'] = ResolversParentTypes['DeleteSiteInspectionPayload']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type DeleteUserPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUserPayload'] = ResolversParentTypes['DeleteUserPayload']> = ResolversObject<{
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
}>;

export type DiaryEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiaryEntry'] = ResolversParentTypes['DiaryEntry']> = ResolversObject<{
  author?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
  projectFileMetadata?: Resolver<ResolversTypes['ProjectFileMetadata'], ParentType, ContextType>;
  projectFiles?: Resolver<Array<ResolversTypes['ProjectFile']>, ParentType, ContextType>;
  siteInspection?: Resolver<ResolversTypes['SiteInspection'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DiaryStatusTypeEnum'], ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['Tag']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  weather?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = ResolversObject<{
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentType?: Resolver<ResolversTypes['DocumentTypeEnum'], ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  uploadedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['DocumentVisibilityEnum'], ParentType, ContextType>;
}>;

export type FinancialEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialEntry'] = ResolversParentTypes['FinancialEntry']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['Attachment']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  entryType?: Resolver<ResolversTypes['TransactionKindEnum'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  paidAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  project?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
  referenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FinancialStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
}>;

export type FinancialSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSummary'] = ResolversParentTypes['FinancialSummary']> = ResolversObject<{
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nextDueDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  overdueAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalCharges?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalCredits?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPayments?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export interface Iso8601DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601Date'], any> {
  name: 'ISO8601Date';
}

export interface Iso8601DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601DateTime'], any> {
  name: 'ISO8601DateTime';
}

export type InstallmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Installment'] = ResolversParentTypes['Installment']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  dueDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paidAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InstallmentStatusEnum'], ParentType, ContextType>;
}>;

export type InvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invitation'] = ResolversParentTypes['Invitation']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inviterName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InvitationStatus'], ParentType, ContextType>;
  userExists?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type InviteUserPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteUserPayload'] = ResolversParentTypes['InviteUserPayload']> = ResolversObject<{
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type InviteUserToProjectPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteUserToProjectPayload'] = ResolversParentTypes['InviteUserToProjectPayload']> = ResolversObject<{
  invitation?: Resolver<ResolversTypes['Invitation'], ParentType, ContextType>;
}>;

export type MarkFinancialEntryAsPaidPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkFinancialEntryAsPaidPayload'] = ResolversParentTypes['MarkFinancialEntryAsPaidPayload']> = ResolversObject<{
  financialEntry?: Resolver<ResolversTypes['FinancialEntry'], ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  acceptInvitation?: Resolver<Maybe<ResolversTypes['AcceptInvitationPayload']>, ParentType, ContextType, RequireFields<MutationAcceptInvitationArgs, 'token'>>;
  acceptUserInvitation?: Resolver<Maybe<ResolversTypes['AcceptUserInvitationPayload']>, ParentType, ContextType, RequireFields<MutationAcceptUserInvitationArgs, 'input'>>;
  changePassword?: Resolver<Maybe<ResolversTypes['ChangePasswordPayload']>, ParentType, ContextType, RequireFields<MutationChangePasswordArgs, 'input'>>;
  createDiaryEntry?: Resolver<Maybe<ResolversTypes['CreateDiaryEntryPayload']>, ParentType, ContextType, RequireFields<MutationCreateDiaryEntryArgs, 'input'>>;
  createDocument?: Resolver<Maybe<ResolversTypes['CreateDocumentPayload']>, ParentType, ContextType, RequireFields<MutationCreateDocumentArgs, 'attachment' | 'projectId'>>;
  createFinancialEntry?: Resolver<Maybe<ResolversTypes['CreateFinancialEntryPayload']>, ParentType, ContextType, RequireFields<MutationCreateFinancialEntryArgs, 'amount' | 'description' | 'entryType' | 'projectId'>>;
  createProject?: Resolver<Maybe<ResolversTypes['CreateProjectPayload']>, ParentType, ContextType, RequireFields<MutationCreateProjectArgs, 'name' | 'paymentMethod'>>;
  createSiteInspection?: Resolver<Maybe<ResolversTypes['CreateSiteInspectionPayload']>, ParentType, ContextType, RequireFields<MutationCreateSiteInspectionArgs, 'projectId'>>;
  createUser?: Resolver<Maybe<ResolversTypes['CreateUserPayload']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input'>>;
  deleteDiaryEntry?: Resolver<Maybe<ResolversTypes['DeleteDiaryEntryPayload']>, ParentType, ContextType, RequireFields<MutationDeleteDiaryEntryArgs, 'id'>>;
  deleteDocument?: Resolver<Maybe<ResolversTypes['DeleteDocumentPayload']>, ParentType, ContextType, RequireFields<MutationDeleteDocumentArgs, 'id'>>;
  deleteProject?: Resolver<Maybe<ResolversTypes['DeleteProjectPayload']>, ParentType, ContextType, RequireFields<MutationDeleteProjectArgs, 'id'>>;
  deleteProjectFile?: Resolver<Maybe<ResolversTypes['DeleteProjectFilePayload']>, ParentType, ContextType, RequireFields<MutationDeleteProjectFileArgs, 'id'>>;
  deleteSiteInspection?: Resolver<Maybe<ResolversTypes['DeleteSiteInspectionPayload']>, ParentType, ContextType, RequireFields<MutationDeleteSiteInspectionArgs, 'id'>>;
  deleteUser?: Resolver<Maybe<ResolversTypes['DeleteUserPayload']>, ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'id'>>;
  inviteUser?: Resolver<Maybe<ResolversTypes['InviteUserPayload']>, ParentType, ContextType, RequireFields<MutationInviteUserArgs, 'input'>>;
  inviteUserToProject?: Resolver<Maybe<ResolversTypes['InviteUserToProjectPayload']>, ParentType, ContextType, RequireFields<MutationInviteUserToProjectArgs, 'email' | 'projectId'>>;
  markFinancialEntryAsPaid?: Resolver<Maybe<ResolversTypes['MarkFinancialEntryAsPaidPayload']>, ParentType, ContextType, RequireFields<MutationMarkFinancialEntryAsPaidArgs, 'id'>>;
  removeProjectMember?: Resolver<Maybe<ResolversTypes['RemoveProjectMemberPayload']>, ParentType, ContextType, RequireFields<MutationRemoveProjectMemberArgs, 'projectId' | 'userId'>>;
  resendInvitation?: Resolver<Maybe<ResolversTypes['ResendInvitationPayload']>, ParentType, ContextType, RequireFields<MutationResendInvitationArgs, 'email'>>;
  signIn?: Resolver<Maybe<ResolversTypes['SignInPayload']>, ParentType, ContextType, RequireFields<MutationSignInArgs, 'email' | 'password'>>;
  signOut?: Resolver<Maybe<ResolversTypes['SignOutPayload']>, ParentType, ContextType>;
  signUp?: Resolver<Maybe<ResolversTypes['SignUpPayload']>, ParentType, ContextType, RequireFields<MutationSignUpArgs, 'email' | 'fullName' | 'password' | 'passwordConfirmation'>>;
  signUpWithInvitation?: Resolver<Maybe<ResolversTypes['SignUpWithInvitationPayload']>, ParentType, ContextType, RequireFields<MutationSignUpWithInvitationArgs, 'fullName' | 'password' | 'passwordConfirmation' | 'token'>>;
  updateDiaryEntry?: Resolver<Maybe<ResolversTypes['UpdateDiaryEntryPayload']>, ParentType, ContextType, RequireFields<MutationUpdateDiaryEntryArgs, 'id'>>;
  updateDocument?: Resolver<Maybe<ResolversTypes['UpdateDocumentPayload']>, ParentType, ContextType, RequireFields<MutationUpdateDocumentArgs, 'id'>>;
  updateProject?: Resolver<Maybe<ResolversTypes['UpdateProjectPayload']>, ParentType, ContextType, RequireFields<MutationUpdateProjectArgs, 'id'>>;
  updateProjectFile?: Resolver<Maybe<ResolversTypes['UpdateProjectFilePayload']>, ParentType, ContextType, RequireFields<MutationUpdateProjectFileArgs, 'id'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['UpdateUserPayload']>, ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'id' | 'input'>>;
  uploadProjectFile?: Resolver<Maybe<ResolversTypes['UploadProjectFilePayload']>, ParentType, ContextType, RequireFields<MutationUploadProjectFileArgs, 'attachment' | 'category' | 'fileType' | 'name' | 'projectId'>>;
}>;

export type PageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']> = ResolversObject<{
  currentPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemsInPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nextPage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prevPage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  series?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = ResolversObject<{
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['Project'] = ResolversParentTypes['Project']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  creator?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  hasAdhocTracking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasConstructionTracking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasFinancialAccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  internalNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectFileMetadata?: Resolver<Maybe<ResolversTypes['ProjectFileMetadata']>, ParentType, ContextType>;
  siteInspections?: Resolver<Array<ResolversTypes['SiteInspection']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ProjectStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
}>;

export type ProjectConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectConnection'] = ResolversParentTypes['ProjectConnection']> = ResolversObject<{
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProjectEdge']>>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Project']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
}>;

export type ProjectEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectEdge'] = ResolversParentTypes['ProjectEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
}>;

export type ProjectFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectFile'] = ResolversParentTypes['ProjectFile']> = ResolversObject<{
  category?: Resolver<ResolversTypes['ProjectFileCategoryEnum'], ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  diaryEntryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  fileType?: Resolver<ResolversTypes['ProjectFileKindEnum'], ParentType, ContextType>;
  folder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uploadedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  uploadedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['ProjectFileVisibilityEnum'], ParentType, ContextType>;
}>;

export type ProjectFileCountByMediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectFileCountByMedia'] = ResolversParentTypes['ProjectFileCountByMedia']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mediaType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type ProjectFileMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectFileMetadata'] = ResolversParentTypes['ProjectFileMetadata']> = ResolversObject<{
  countsByMediaType?: Resolver<Array<ResolversTypes['ProjectFileCountByMedia']>, ParentType, ContextType>;
}>;

export type ProjectFinancialSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectFinancialSummary'] = ResolversParentTypes['ProjectFinancialSummary']> = ResolversObject<{
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalContractsValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalOverdue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPending?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type ProjectMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectMembership'] = ResolversParentTypes['ProjectMembership']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  currentUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  diaryEntries?: Resolver<Array<ResolversTypes['DiaryEntry']>, ParentType, ContextType, RequireFields<QueryDiaryEntriesArgs, 'projectId'>>;
  document?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<QueryDocumentArgs, 'id'>>;
  documents?: Resolver<Array<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<QueryDocumentsArgs, 'projectId'>>;
  financialEntries?: Resolver<Array<ResolversTypes['FinancialEntry']>, ParentType, ContextType, RequireFields<QueryFinancialEntriesArgs, 'projectId'>>;
  financialSummary?: Resolver<ResolversTypes['FinancialSummary'], ParentType, ContextType, RequireFields<QueryFinancialSummaryArgs, 'projectId'>>;
  invitation?: Resolver<Maybe<ResolversTypes['Invitation']>, ParentType, ContextType, RequireFields<QueryInvitationArgs, 'token'>>;
  invitedUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<QueryProjectArgs, 'id'>>;
  projectContracts?: Resolver<Array<ResolversTypes['Contract']>, ParentType, ContextType, RequireFields<QueryProjectContractsArgs, 'projectId'>>;
  projectFile?: Resolver<Maybe<ResolversTypes['ProjectFile']>, ParentType, ContextType, RequireFields<QueryProjectFileArgs, 'id'>>;
  projectFiles?: Resolver<Array<ResolversTypes['ProjectFile']>, ParentType, ContextType, RequireFields<QueryProjectFilesArgs, 'projectId'>>;
  projectFinancialSummary?: Resolver<ResolversTypes['ProjectFinancialSummary'], ParentType, ContextType, RequireFields<QueryProjectFinancialSummaryArgs, 'projectId'>>;
  projectSiteInspections?: Resolver<ResolversTypes['SiteInspectionPage'], ParentType, ContextType, RequireFields<QueryProjectSiteInspectionsArgs, 'limit' | 'page' | 'projectId'>>;
  projects?: Resolver<ResolversTypes['ProjectConnection'], ParentType, ContextType, Partial<QueryProjectsArgs>>;
  tags?: Resolver<Array<ResolversTypes['Tag']>, ParentType, ContextType, Partial<QueryTagsArgs>>;
  userInvitation?: Resolver<Maybe<ResolversTypes['UserInvitation']>, ParentType, ContextType, RequireFields<QueryUserInvitationArgs, 'token'>>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
}>;

export type RemoveProjectMemberPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveProjectMemberPayload'] = ResolversParentTypes['RemoveProjectMemberPayload']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type ResendInvitationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendInvitationPayload'] = ResolversParentTypes['ResendInvitationPayload']> = ResolversObject<{
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type SignInPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignInPayload'] = ResolversParentTypes['SignInPayload']> = ResolversObject<{
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type SignOutPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignOutPayload'] = ResolversParentTypes['SignOutPayload']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type SignUpPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignUpPayload'] = ResolversParentTypes['SignUpPayload']> = ResolversObject<{
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type SignUpWithInvitationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignUpWithInvitationPayload'] = ResolversParentTypes['SignUpWithInvitationPayload']> = ResolversObject<{
  projectMembership?: Resolver<ResolversTypes['ProjectMembership'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type SiteInspectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SiteInspection'] = ResolversParentTypes['SiteInspection']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  diaryEntries?: Resolver<Array<ResolversTypes['DiaryEntry']>, ParentType, ContextType>;
  displayLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
  sequence?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
}>;

export type SiteInspectionPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SiteInspectionPage'] = ResolversParentTypes['SiteInspectionPage']> = ResolversObject<{
  nodes?: Resolver<Array<ResolversTypes['SiteInspection']>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Page'], ParentType, ContextType>;
}>;

export type TagResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tag'] = ResolversParentTypes['Tag']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type UpdateDiaryEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateDiaryEntryPayload'] = ResolversParentTypes['UpdateDiaryEntryPayload']> = ResolversObject<{
  diaryEntry?: Resolver<ResolversTypes['DiaryEntry'], ParentType, ContextType>;
}>;

export type UpdateDocumentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateDocumentPayload'] = ResolversParentTypes['UpdateDocumentPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['Document'], ParentType, ContextType>;
}>;

export type UpdateProjectFilePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateProjectFilePayload'] = ResolversParentTypes['UpdateProjectFilePayload']> = ResolversObject<{
  projectFile?: Resolver<ResolversTypes['ProjectFile'], ParentType, ContextType>;
}>;

export type UpdateProjectPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateProjectPayload'] = ResolversParentTypes['UpdateProjectPayload']> = ResolversObject<{
  project?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
}>;

export type UpdateUserPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserPayload'] = ResolversParentTypes['UpdateUserPayload']> = ResolversObject<{
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UploadProjectFilePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadProjectFilePayload'] = ResolversParentTypes['UploadProjectFilePayload']> = ResolversObject<{
  projectFile?: Resolver<ResolversTypes['ProjectFile'], ParentType, ContextType>;
}>;

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  disabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  disabledAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  forcePasswordChange?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  invitedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
}>;

export type UserInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInvitation'] = ResolversParentTypes['UserInvitation']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invitee?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  inviter?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  AcceptInvitationPayload?: AcceptInvitationPayloadResolvers<ContextType>;
  AcceptUserInvitationPayload?: AcceptUserInvitationPayloadResolvers<ContextType>;
  Attachment?: AttachmentResolvers<ContextType>;
  ChangePasswordPayload?: ChangePasswordPayloadResolvers<ContextType>;
  Contract?: ContractResolvers<ContextType>;
  CreateDiaryEntryPayload?: CreateDiaryEntryPayloadResolvers<ContextType>;
  CreateDocumentPayload?: CreateDocumentPayloadResolvers<ContextType>;
  CreateFinancialEntryPayload?: CreateFinancialEntryPayloadResolvers<ContextType>;
  CreateProjectPayload?: CreateProjectPayloadResolvers<ContextType>;
  CreateSiteInspectionPayload?: CreateSiteInspectionPayloadResolvers<ContextType>;
  CreateUserPayload?: CreateUserPayloadResolvers<ContextType>;
  DeleteDiaryEntryPayload?: DeleteDiaryEntryPayloadResolvers<ContextType>;
  DeleteDocumentPayload?: DeleteDocumentPayloadResolvers<ContextType>;
  DeleteProjectFilePayload?: DeleteProjectFilePayloadResolvers<ContextType>;
  DeleteProjectPayload?: DeleteProjectPayloadResolvers<ContextType>;
  DeleteSiteInspectionPayload?: DeleteSiteInspectionPayloadResolvers<ContextType>;
  DeleteUserPayload?: DeleteUserPayloadResolvers<ContextType>;
  DiaryEntry?: DiaryEntryResolvers<ContextType>;
  Document?: DocumentResolvers<ContextType>;
  FinancialEntry?: FinancialEntryResolvers<ContextType>;
  FinancialSummary?: FinancialSummaryResolvers<ContextType>;
  ISO8601Date?: GraphQLScalarType;
  ISO8601DateTime?: GraphQLScalarType;
  Installment?: InstallmentResolvers<ContextType>;
  Invitation?: InvitationResolvers<ContextType>;
  InviteUserPayload?: InviteUserPayloadResolvers<ContextType>;
  InviteUserToProjectPayload?: InviteUserToProjectPayloadResolvers<ContextType>;
  MarkFinancialEntryAsPaidPayload?: MarkFinancialEntryAsPaidPayloadResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Project?: ProjectResolvers<ContextType>;
  ProjectConnection?: ProjectConnectionResolvers<ContextType>;
  ProjectEdge?: ProjectEdgeResolvers<ContextType>;
  ProjectFile?: ProjectFileResolvers<ContextType>;
  ProjectFileCountByMedia?: ProjectFileCountByMediaResolvers<ContextType>;
  ProjectFileMetadata?: ProjectFileMetadataResolvers<ContextType>;
  ProjectFinancialSummary?: ProjectFinancialSummaryResolvers<ContextType>;
  ProjectMembership?: ProjectMembershipResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RemoveProjectMemberPayload?: RemoveProjectMemberPayloadResolvers<ContextType>;
  ResendInvitationPayload?: ResendInvitationPayloadResolvers<ContextType>;
  SignInPayload?: SignInPayloadResolvers<ContextType>;
  SignOutPayload?: SignOutPayloadResolvers<ContextType>;
  SignUpPayload?: SignUpPayloadResolvers<ContextType>;
  SignUpWithInvitationPayload?: SignUpWithInvitationPayloadResolvers<ContextType>;
  SiteInspection?: SiteInspectionResolvers<ContextType>;
  SiteInspectionPage?: SiteInspectionPageResolvers<ContextType>;
  Tag?: TagResolvers<ContextType>;
  UpdateDiaryEntryPayload?: UpdateDiaryEntryPayloadResolvers<ContextType>;
  UpdateDocumentPayload?: UpdateDocumentPayloadResolvers<ContextType>;
  UpdateProjectFilePayload?: UpdateProjectFilePayloadResolvers<ContextType>;
  UpdateProjectPayload?: UpdateProjectPayloadResolvers<ContextType>;
  UpdateUserPayload?: UpdateUserPayloadResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  UploadProjectFilePayload?: UploadProjectFilePayloadResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserInvitation?: UserInvitationResolvers<ContextType>;
}>;

